<div class="input-group">
  <input
    class="form-control"
    [placeholder]="placeholder"
    ngbDatepicker
    #edDatepicker="ngbDatepicker"
    [disabled]="disabled"
    [(ngModel)]="model"
    [ngModelOptions]="{ standalone: true }"
    (ngModelChange)="onDateChanged($event)"
    (blur)="onTouched()"
  />
  <button
    class="btn btn-outline-secondary bi bi-calendar3"
    type="button"
    (click)="edDatepicker.toggle()"
    [disabled]="disabled"
    aria-label="Ouvrir le sélecteur de date"
  ></button>
</div>
